import { getKeys as getExternalCompetitionsKeys } from '../../../components/form/InputExternalCompetitions';
import type { Page } from '../../types';
import { REPORTING_PERIOD } from './shared_variables';

const internalCompetitions: Page[] = [
  {
    pageType: 'question',
    title: 'Internal competitions',
    name: 'internal-competitions-page',
    hidePageTitle: true,
    hideContinueButton: true,
    navigateToSummaryOnComplete: true,
    questions: [
      {
        questionType: 'internalCompetitionsInput',
        title: '',
        name: 'internal-competitions-input',
        hint: `Please confirm the number of posts advertised in Civil Service-wide competitions (not advertised publicly) at each grade between ${REPORTING_PERIOD}`,
        detailsContent: `<p>If the grade does not align directly, you can use the equivalent.</p>
                         <p>The data provided in this section should include numbers from any arm's length bodies, if these numbers relate to the appointment of civil servants or the advertisement of civil service vacancies. </p>`,
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInputSmall',
        title: 'Total',
        name: 'internal-competitions-total',
        rules: {
          required: true,
        },
        customValidation: {
          sumEqualToPreviousAnswer: 'headline-exceptions',
        },
        autoFill: {
          keys: getExternalCompetitionsKeys(),
          field: 'internal-competitions-input',
        },
      },
    ],
  },
];
export default internalCompetitions;
